import { render, staticRenderFns } from "./CentralTransfer.vue?vue&type=template&id=5b272d88&scoped=true&"
import script from "./CentralTransfer.vue?vue&type=script&lang=js&"
export * from "./CentralTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CentralTransfer.vue?vue&type=style&index=0&id=5b272d88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b272d88",
  null
  
)

export default component.exports